import { render, staticRenderFns } from "./ItemSelectionDialog.vue?vue&type=template&id=5ea8563c&scoped=true"
import script from "./ItemSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ItemSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./ItemSelectionDialog.vue?vue&type=style&index=0&id=5ea8563c&prod&lang=css&scoped=true"
import style1 from "./ItemSelectionDialog.vue?vue&type=style&index=1&id=5ea8563c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8563c",
  null
  
)

export default component.exports